// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"b44f095d","294":"3df3cb77","433":"3912f4f9","637":"8effeeaa","768":"c0b0a7de"}[chunkId] + ".chunk.js";
};